export const TOKEN_NAME = 'token';
export const ROUTE_PATH = {
    companiesManagement: "/companies",
    licenses: "/licences",
    usersManagement: "/users",
    auditLog: "/audit-log",
    alerts: "/alerts",
};

export const NAV_LINK_LABELS = {
    companiesManagement: "Companies",
    licenses: "Licences",
    usersManagement: "Users",
    auditLog: "Audit Log",
    alerts: "Alerts",
}

export const REACT_APP_VERSION='1.0.0';
export const KEY_LANGUAGE_SESSION_STORAGE="LANGUAGE"
